import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { dateFormat } from 'common/helpers/dateHelper';

const LoyaltyTransactionRow = (props) => {
  const { loyaltyTransaction } = props;
  const settings = useSelector((state) => state.setting);

  return (
    <div className="c7-account__reservation">
      <div>{dateFormat(loyaltyTransaction.transactionDate, settings)}</div>
      <div>
        <strong>Order No.</strong>
        <br />
        {loyaltyTransaction.orderNumber || '--'}
      </div>
      <div>
        <strong>Type</strong>
        <br />
        {loyaltyTransaction.transactionType}
      </div>
      <div>
        <strong>Details</strong>
        <br />
        {loyaltyTransaction.transactionDetails}
      </div>
      <div>
        <strong>Points.</strong>
        <br />
        <strong>{loyaltyTransaction.amount}</strong>
      </div>
      <div>
        {loyaltyTransaction.orderId && (
          <Link
            to={`/profile/order-history/${loyaltyTransaction.orderId}`}
            className="c7-button-alt-small"
          >
            {' '}
            View order
          </Link>
        )}
        {!loyaltyTransaction.orderId && <>--</>}
      </div>
    </div>
  );
};

export default LoyaltyTransactionRow;
